import { ModalStore } from '../../state/ModalStore'
import HomepageBookCallLeadModal from '../Modals/HomepageBookCallLeadModal'

function XIcon({ className }) {
    return (
        <svg
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
    )
}

function CheckCircleIcon({ className }) {
    return (
        <svg
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round">
            <polyline points="20 6 9 17 4 12" />
        </svg>
    )
}

const COMPARISONS = [
    {
        bad: {
            title: 'Slow campaign launches',
            desc: 'New movers pick a dentist before mail ever drops',
        },
        good: {
            title: '2-day trigger mail',
            desc: 'Drops in mailboxes within 2 business days of the trigger event',
        },
    },
    {
        bad: {
            title: 'Generic ZIP-code blasts',
            desc: 'Broad coverage with no patient signal',
        },
        good: {
            title: 'Event-triggered audiences',
            desc: 'New movers, new patient specials, recall, reactivation, and family households',
        },
    },
    {
        bad: {
            title: 'No response visibility',
            desc: 'Hard to see which campaign drove the booked appointment',
        },
        good: {
            title: 'Response tracking',
            desc: 'Per-campaign call tracking, QR codes, and reporting by offer and audience',
        },
    },
]

export default function WhyOLM({ onBookCall }) {
    const addModal = ModalStore((state) => state.add)
    const handleBookCall = () => {
        if (onBookCall) {
            onBookCall()
            return
        }

        addModal(<HomepageBookCallLeadModal />)
    }

    return (
        <section className="bg-[#3F454F]">
            <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-6 px-6 py-8 lg:grid-cols-2 lg:gap-10 lg:px-8 lg:py-14">
                <div className="flex flex-col gap-4">
                    <span className="text-xs font-semibold uppercase tracking-widest text-[#FDB515]">
                        Why OLM
                    </span>
                    <h2
                        className="text-3xl font-bold tracking-tight text-white md:text-[44px]"
                        style={{ lineHeight: 1.05 }}>
                        Built for dental practices that need to be first in the
                        mailbox.
                    </h2>
                    <p
                        className="text-lg text-white/70"
                        style={{ lineHeight: '28px' }}>
                        Booking windows are short. A new mover picks a dentist
                        within weeks. A lapsed patient is one competitor
                        postcard away. We help you trigger mail off fresh data
                        so your offer lands while the patient is still deciding.
                    </p>
                    <div className="mt-2">
                        <button
                            type="button"
                            onClick={handleBookCall}
                            className="inline-flex w-fit cursor-pointer rounded-full px-6 py-3 text-base font-semibold text-white transition-shadow"
                            style={{
                                background:
                                    'linear-gradient(to right, #ED5C2F 20%, #F28230 70%, #FAB331 110%)',
                                boxShadow:
                                    '0 0 9px rgba(237,92,47,0.28), 0 1px 4px rgba(237,92,47,0.22)',
                            }}
                            onMouseOver={(e) =>
                                (e.currentTarget.style.boxShadow =
                                    '0 0 13px rgba(237,92,47,0.42), 0 2px 7px rgba(237,92,47,0.3)')
                            }
                            onMouseOut={(e) =>
                                (e.currentTarget.style.boxShadow =
                                    '0 0 9px rgba(237,92,47,0.28), 0 1px 4px rgba(237,92,47,0.22)')
                            }>
                            Book a call &rarr;
                        </button>
                    </div>
                </div>

                <div className="flex flex-col gap-2">
                    <div className="hidden grid-cols-2 gap-4 px-5 lg:grid">
                        <span className="text-xs font-semibold uppercase tracking-widest text-white/40">
                            Other vendors
                        </span>
                        <span className="text-xs font-semibold uppercase tracking-widest text-[#FDB515]">
                            OLM
                        </span>
                    </div>

                    {COMPARISONS.map((row, i) => (
                        <div
                            key={i}
                            className="grid grid-cols-1 gap-3 rounded-xl border border-white/10 bg-white/5 p-3.5 transition-all duration-200 hover:border-white/20 hover:bg-white/[0.08] lg:grid-cols-2">
                            <div className="flex flex-row items-start gap-3">
                                <div className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-secondary/20">
                                    <XIcon className="h-3 w-3 text-secondary" />
                                </div>
                                <div className="text-sm text-white/60">
                                    <strong className="text-white/60">
                                        {row.bad.title}
                                    </strong>
                                    <br />
                                    {row.bad.desc}
                                </div>
                            </div>

                            <div className="mt-1 flex flex-row items-start gap-3 border-t border-white/10 pt-3 lg:mt-0 lg:border-t-0 lg:pt-0">
                                <div className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-emerald-500/20">
                                    <CheckCircleIcon className="h-3 w-3 text-emerald-500" />
                                </div>
                                <div className="text-sm text-white">
                                    <strong>{row.good.title}</strong>
                                    <br />
                                    <span className="text-white/80">
                                        {row.good.desc}
                                    </span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}
